export const dummyTransactionData = {
    data: [
      {
        id: 1,
        member_id: 101,
        member_name: "John Doe",
        transaction_date: "2024-11-28T14:35:00Z",
        main_transaction_id: null,
        receipt_number: "REC123456",
        transaction_type: "purchase",
        status: "completed",
        invoice_details: [
          {
            id: 1,
            transaction_id: 1,
            item_id: 501,
            quantity: 2,
            description: "Premium Membership",
            item_type: "service",
            assigned_members: [101],
            total: 200.0,
          },
          {
            id: 2,
            transaction_id: 1,
            item_id: 502,
            quantity: 1,
            description: "Protein Powder",
            item_type: "product",
            assigned_members: [],
            total: 50.0,
          },
        ],
        payment_details: [
          {
            id: 1,
            transaction_id: 1,
            payment_method_id: 1,
            payment_method: "Credit Card",
            amount: 250.0,
          },
        ],
        added_member_ids: [102, 103],
        total_quantity: 3,
        total_amount: 250.0,
      },
      {
        id: 2,
        member_id: 102,
        member_name: "Jane Smith",
        transaction_date: "2024-11-27T10:20:00Z",
        main_transaction_id: 1,
        receipt_number: "REC123457",
        transaction_type: "refund",
        status: "pending",
        invoice_details: [
          {
            id: 3,
            transaction_id: 2,
            item_id: 503,
            quantity: 1,
            description: "Yoga Class Package",
            item_type: "service",
            assigned_members: [102],
            total: 75.0,
          },
        ],
        payment_details: [
          {
            id: 2,
            transaction_id: 2,
            payment_method_id: 2,
            payment_method: "PayPal",
            amount: 75.0,
          },
        ],
        added_member_ids: null,
        total_quantity: 1,
        total_amount: 75.0,
      },
    ],
    total_counts: 2,
    filtered_counts: 2,
  };
  